import { useInView } from "@/hooks/useInView";

const COACH_IMG = "https://customer-assets.emergentagent.com/job_premium-confidence/artifacts/pi3j0rvt_IMG_0021.jpeg";

export default function CoachSection() {
  const [ref, inView] = useInView();

  return (
    <section id="coach" data-testid="coach-section" className="bg-[#050505] py-16 sm:py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className={`order-2 md:order-1 reveal-left ${inView ? 'visible' : ''}`}>
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] font-body mb-4">Your Coach</p>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#F2EFE9] mb-2">
              Darius Yancy
            </h2>
            <p className="text-sm text-[#D4AF37] font-body tracking-wide uppercase mb-6">
              Founder, 3SM Training &amp; Programming
            </p>
            <blockquote className="border-l-2 border-[#D4AF37]/40 pl-4 mb-6">
              <p className="text-[#F2EFE9] font-heading text-lg sm:text-xl font-semibold italic leading-snug">
                &ldquo;Not aggression, but composure<br />under pressure.&rdquo;
              </p>
            </blockquote>
            <div className="space-y-4 text-[#8C8C8C] font-body text-sm leading-relaxed">
              <p>
                Darius Yancy is the founder and creator of 3SM Training &amp; Programming, a trauma-informed
                system built around Strength, Self-Defense, and Striking Mindset. A former professional MMA
                fighter, boxing and self-defense coach, Brazilian jiu-jitsu purple belt, author, and
                youth-development instructor, Darius brings more than 15 years of training and coaching
                experience to individuals, families, schools, nonprofits, gyms, and professional organizations.
              </p>
              <p>
                His work combines practical physical instruction with situational awareness, boundary-setting,
                confidence development, nervous-system regulation, and composure under pressure. He is also
                the creator of 3SM Executive Composure&trade;, ARRP, DCAE, and the 4D instructional method.
              </p>
              <p>
                Darius believes strength should be disciplined, protective, responsible, and useful beyond
                the training floor.
              </p>
            </div>
          </div>
          <div className={`order-1 md:order-2 reveal-right ${inView ? 'visible' : ''} stagger-2`}>
            <div className="rounded-lg overflow-hidden border border-white/10 aspect-[3/2] animate-glow">
              <img src={COACH_IMG} alt="Coach Darius Yancy - 3SM Founder" className="w-full h-full object-cover object-[center_15%] hover:scale-105 transition-transform duration-700" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
